// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-label[data-v-1e050188],[class^=el-icon-][data-v-1e050188]{font-weight:700}.details-label[data-v-1e050188]{width:75px;margin-right:20px}.details-label[data-v-1e050188]:after{content:\":\"}", ""]);
// Exports
module.exports = exports;
